import ArrowDropDownIcon from '@mui/icons-material/ArrowDropDown';
import CheckIcon from '@mui/icons-material/Check';
import PublicIcon from '@mui/icons-material/Public';
import Box from '@mui/material/Box';
import Button from '@mui/material/Button';
import ListItemIcon from '@mui/material/ListItemIcon';
import Menu from '@mui/material/Menu';
import MenuItem from '@mui/material/MenuItem';
import {func, object} from 'prop-types';
import React, {useCallback, useState} from 'react';
import {useSearchParams} from 'react-router';

function MapToggle({sx, onChange}) {
  const [searchParams] = useSearchParams();
  const geometry = searchParams.get('geometry');
  const [anchorEl, setAnchorEl] = useState(null);
  const open = !!anchorEl;

  const onButtonClick = useCallback(event => {
    setAnchorEl(event.currentTarget);
  }, []);

  const onMenuClose = useCallback(() => {
    setAnchorEl(null);
  }, []);

  const onMenuItemClick = useCallback(
    value => {
      setAnchorEl(null);
      onChange(value);
    },
    [onChange],
  );

  const label = geometry ? 'Map Search' : 'All Locations';
  const color = geometry ? 'primary' : 'secondary';

  return (
    <Box sx={sx}>
      <Button
        onClick={onButtonClick}
        variant="outlined"
        size="small"
        color={color}
        startIcon={<PublicIcon />}
        endIcon={<ArrowDropDownIcon />}
      >
        {label}
      </Button>
      <Menu anchorEl={anchorEl} open={open} onClose={onMenuClose}>
        <MenuItem
          onClick={() => onMenuItemClick(false)}
          dense
          sx={{textTransform: 'uppercase'}}
        >
          All Locations
        </MenuItem>
        <MenuItem
          onClick={() => onMenuItemClick(true)}
          dense
          sx={{textTransform: 'uppercase'}}
        >
          Map Search
          <ListItemIcon sx={{marginLeft: 2}}>
            {geometry ? <CheckIcon fontSize="small" /> : null}
          </ListItemIcon>
        </MenuItem>
      </Menu>
    </Box>
  );
}

MapToggle.propTypes = {
  sx: object,
  onChange: func.isRequired,
};

export default MapToggle;
